export default "__VITE_ASSET__BCMU5CE7__"